import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';


const Skeleton = ({ height = '40vh', type = 'default' }) => {
  return (
    <div className={`skeleton ${type}`} style={{ height }} />
  );
};

Skeleton.propTypes = {
  height: PropTypes.string,
  type: PropTypes.oneOf(['default', 'banners', 'category', 'listers']),
};

export default Skeleton;
